import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { Observable, of } from "rxjs";
import { delay, tap } from "rxjs/operators";
import { ProfesionalId, TotalCapita } from "src/common/menuUsuario";
import { environment } from "src/environments/environment";

@Injectable()
export class MenuUsuarioService {

	private readonly BASE_URL: string = environment.backendUrl;
	private readonly FIND_PROFESIONAL_AUTORIZADO_ID_URL: string = this.BASE_URL + '/comprobante-tesoreria/profesional-autorizado/id';
	private readonly FIND_TOTAL_CAPITA_URL: string = this.BASE_URL + '/capita-paciente/total';
	private readonly FIND_YEARS_APORTES: string = this.BASE_URL + '/aporte-plansalud/years';


	constructor( private http: HttpClient ) {
	}

	findYearsAportesPS(): Observable<number[]> {
		return this.http.get<number[]>( this.FIND_YEARS_APORTES );
	}

	findProfesionalesAutorizadosIds(): Observable<ProfesionalId[]> {
		return this.http.get<ProfesionalId[]>( this.FIND_PROFESIONAL_AUTORIZADO_ID_URL );
	}

	findTotalCapita(): Observable<TotalCapita> {
		return this.http.get<TotalCapita>( this.FIND_TOTAL_CAPITA_URL );
	}

}